<template>
  <div class="menu-folder-modern">
    <!-- Header Section -->
    <div class="folders-header">
      <div class="header-content">
        <div class="title-section">
          <h2 class="section-title">
            <i class="fas fa-mobile-alt title-icon"></i>

            WhatsApp
          </h2>

          <p class="section-subtitle">
            Gerencie e personalize as mensagens automáticas do residente
          </p>
        </div>
      </div>
    </div>

    <div class="folder-content">
      <div
        class="folder-section"
        v-if="permission('read', 'whatsapp_report_medicine')"
      >
        <div class="section-header">
          <div class="section-title">
            <i class="fas fa-notes-medical section-icon"></i>
            <h3>Relatórios de medicamentos</h3>
          </div>
        </div>
        <div class="section-content">
          <ListPhoneNumber
            :resident_id="resident_id"
            :type="'REPORT_MEDICINE'"
          />
        </div>
      </div>

      <div class="folder-section" v-if="false">
        <div class="section-header">
          <div class="section-title">
            <i class="fas fa-heart section-icon"></i>
            <h3>Relatórios de cuidados</h3>
          </div>
        </div>
        <div class="section-content">
          <ListPhoneNumber :resident_id="resident_id" :type="'REPORT_CARE'" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ListPhoneNumber from "../../templates/WhatsAppResident/ListPhoneNumber";

import permission from "../../lib/permission";

export default {
  name: "MenuWhatsApp",

  components: {
    ListPhoneNumber,
  },

  props: {
    resident_id: Number,
  },

  data() {
    return {
      loading: false,
    };
  },

  methods: {
    permission,
  },
};
</script>

<style scoped>
.btn-edit-modern {
  background: linear-gradient(135deg, #1d75be 0%, #155a8a 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 8px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  font-size: 12px !important;
  box-shadow: 0 2px 8px rgba(29, 117, 190, 0.25) !important;
  transition: all 0.3s ease !important;
}

.btn-edit-modern:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 12px rgba(29, 117, 190, 0.35) !important;
}

.menu-folder-modern {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 0;
}

/* Header Section */
.folders-header {
  background: white;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
}

.title-section {
  flex: 1;
}

.section-title {
  font-size: 24px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
  display: flex;
  align-items: center;
  font-family: "WorkSans-SemiBold", sans-serif;
}

.title-icon {
  color: #0f65b0;
  margin-right: 12px;
  font-size: 20px;
}

.section-subtitle {
  color: #64748b;
  margin: 4px 0 0 0;
  font-size: 14px;
}

.actions-section {
  display: flex;
  gap: 12px;
}

/* Modern Button */
.btn-add-modern {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;
  margin-left: auto !important;
  display: block !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 12px 24px !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  box-shadow: 0 4px 15px rgba(16, 185, 129, 0.3) !important;
  transition: all 0.3s ease !important;
}

.btn-add-modern:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(16, 185, 129, 0.4) !important;
}

/* Content Section */
.folder-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* Folder Sections */
.folder-section {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  overflow: hidden;
}

.section-header {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  padding: 20px 24px;
  border-bottom: 1px solid #e5e7eb;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 12px;
}

.section-title h3 {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
  flex: 1;
}

.section-icon {
  color: #0f65b0;
  font-size: 16px;
  width: 20px;
  text-align: center;
}

.folder-count {
  background: #0f65b0;
  color: white;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  min-width: 24px;
  text-align: center;
}

.section-content {
  padding: 24px;
}

/* No Results State */
.no-results-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  padding: 48px 24px;
}

.no-results-content {
  text-align: center;
  max-width: 400px;
  margin: 0 auto;
}

.no-results-icon {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px auto;
  border: 2px solid #e5e7eb;
}

.no-results-icon i {
  font-size: 32px;
  color: #94a3b8;
}

.no-results-title {
  font-size: 20px;
  font-weight: 600;
  color: #1e293b;
  margin: 0 0 8px 0;
}

.no-results-text {
  color: #64748b;
  font-size: 14px;
  margin: 0 0 24px 0;
  line-height: 1.5;
}

.no-results-suggestion {
  padding-top: 20px;
  border-top: 1px solid #e5e7eb;
}

.suggestion-text {
  color: #374151;
  font-size: 14px;
  margin: 0 0 16px 0;
  font-weight: 500;
}

.btn-create-suggestion {
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 12px 24px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  box-shadow: 0 4px 15px rgba(15, 101, 176, 0.3) !important;
  transition: all 0.3s ease !important;
}

.btn-create-suggestion:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(15, 101, 176, 0.4) !important;
}

/* Responsive Design */
@media (max-width: 768px) {
  .folder-header {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
    padding: 20px;
  }

  .header-content {
    text-align: center;
  }

  .folder-title {
    font-size: 20px;
    justify-content: center;
  }

  .section-header {
    padding: 16px 20px;
  }

  .section-content {
    padding: 20px;
  }

  .no-results-card {
    padding: 32px 20px;
  }

  .no-results-icon {
    width: 64px;
    height: 64px;
    margin-bottom: 16px;
  }

  .no-results-icon i {
    font-size: 24px;
  }

  .no-results-title {
    font-size: 18px;
  }
}

@media (max-width: 480px) {
  .menu-folder-modern {
    gap: 16px;
  }

  .folder-header {
    padding: 16px;
  }

  .folder-title {
    font-size: 18px;
    flex-direction: column;
    gap: 4px;
  }

  .folder-subtitle {
    font-size: 13px;
  }

  .section-title {
    gap: 8px;
  }

  .section-title h3 {
    font-size: 14px;
  }

  .folder-count {
    font-size: 11px;
    padding: 3px 8px;
  }

  .btn-add-modern,
  .btn-create-suggestion {
    padding: 10px 20px !important;
    font-size: 14px !important;
  }

  .no-results-title {
    font-size: 16px;
  }

  .no-results-text,
  .suggestion-text {
    font-size: 13px;
  }
}

/* Animation for smooth transitions */
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.folder-section {
  animation: slideIn 0.3s ease forwards;
}

.folder-section:nth-child(1) {
  animation-delay: 0.1s;
}

.folder-section:nth-child(2) {
  animation-delay: 0.2s;
}
</style>